import type { Client } from 'openapi-fetch';
import { createApiClient } from '@ngsos/portal-core/http';
import type { EmsPaths } from '@ngsos/portal-core/api/ems';
import { getAuthSession } from './auth';
import { getEmsServerUrl } from './baseUrls';

let client: Client<EmsPaths> | undefined;

function ensureClient(): Client<EmsPaths> {
  client ??= createApiClient<EmsPaths>(getEmsServerUrl(), getAuthSession());
  return client;
}

export const emsApi: Client<EmsPaths> = new Proxy({} as Client<EmsPaths>, {
  get(_target, property) {
    return Reflect.get(ensureClient(), property);
  },
});
